import React from "react";
import { StyledText } from "../assets/typography/typography";

interface LabelProps extends React.HTMLAttributes<HTMLDivElement> {
  backgroundColor: string;
  color: string;
}

export const Label = ({
  backgroundColor,
  color,
  className,
  children,
  style,
  ...rest
}: LabelProps) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center h-auto py-2 px-4 ${className} b-4px`}
      style={{
        ...style,
        backgroundColor,
        width: "fit-content",
      }}
      {...rest}
    >
      <StyledText color={color} className="bodyTextSemibold mb-0">
        {children}
      </StyledText>
    </div>
  );
};

export const InLineLabel = ({
  backgroundColor,
  color,
  className,
  children,
  style,
  ...rest
}: LabelProps) => {
  return (
    <div
      className={`d-flex justify-content-center align-items-center h-auto py-1 px-3 ${className} b-4px`}
      style={{
        ...style,
        backgroundColor,
        width: "fit-content",
      }}
      {...rest}
    >
      <StyledText color={color} className="bodySubtextRegular mb-0">
        {children}
      </StyledText>
    </div>
  );
};
